import React from 'react';

export const Youtube = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
    <path d="M28.153 6.245c-4.805-.327-15.508-.326-20.306 0C2.65 6.6 2.039 9.74 2 18c.039 8.247.645 11.399 5.847 11.755 4.8.326 15.501.327 20.306 0C33.35 29.4 33.961 26.26 34 18c-.039-8.247-.645-11.399-5.847-11.755zM14 23.333V12.667l10.667 5.324L14 23.333z" />
  </svg>
);
